export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_USERS = '/users';
export const ROUTE_USERS_EDIT = '/users/edit';
export const ROUTE_ARTS = '/arts';
export const ROUTE_ARTS_CREATE = '/arts/create';

export const ROUTE_CAFE24_DASHBOARD = '/cafe24';
export const ROUTE_CAFE24_PRODUCT_LIST = '/cafe24/product';
export const ROUTE_CAFE24_ART_LIST = '/cafe24/art';
export const ROUTE_CAFE24_ORDER_LIST = '/cafe24/order';
export const ROUTE_CAFE24_INIT = '/cafe24/init';
export const ROUTE_CAFE24_ERROR = '/cafe24/error';